import React, { useEffect, useState } from 'react';

export default function WelcomeLoader({ onComplete }) {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    // Start fading out after 3 seconds
    setTimeout(() => setFadeOut(true), 3000);
    // Remove the loader completely after 4 seconds
    setTimeout(onComplete, 4000);
  }, [onComplete]);

  return (
    <div
      className={`fixed top-0 left-0 w-full h-full flex flex-col items-center justify-center bg-blue-500 text-white text-2xl font-bold transition-opacity duration-1000 ${fadeOut ? 'opacity-0' : 'opacity-100'}`}
    >
      <h1 className="text-3xl md:text-4xl animate-bounce">Welcome to</h1>
      <h2 className="text-2xl md:text-3xl mt-2 animate-pulse">Skin Disease Prediction System</h2>
    </div>
  );
}
